import { Avatar, type AvatarProps } from '@frontend/components';

export const CustomAvatar = (props: AvatarProps) => (
  <Avatar alignSelf="center" size="xs" {...props} />
);
